export function formatNumber(value: number | null | undefined): string {
  return value === null || value === undefined
    ? "—"
    : value.toLocaleString("ru-RU", { maximumFractionDigits: 1 });
}

export function formatPercent(value: number | null | undefined): string {
  return value === null || value === undefined
    ? "—"
    : `${value.toLocaleString("ru-RU", {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
      })}%`;
}

export function formatBytes(value: number | null | undefined): string {
  if (value === null || value === undefined) {
    return "—";
  }
  const units = ["Б", "КБ", "МБ", "ГБ", "ТБ"];
  let scaled = value;
  let unit = 0;
  while (scaled >= 1024 && unit < units.length - 1) {
    scaled /= 1024;
    unit += 1;
  }
  return `${scaled.toLocaleString("ru-RU", {
    maximumFractionDigits: scaled >= 100 ? 0 : 1
  })} ${units[unit]}`;
}

export function formatSpeed(value: number | null | undefined): string {
  return value === null || value === undefined
    ? "—"
    : `${formatBytes(value)}/с`;
}

export function formatDate(value: string | null | undefined): string {
  if (!value) {
    return "—";
  }
  return new Date(value).toLocaleString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  });
}

export function shortId(value: string, length = 10): string {
  return value.length <= length ? value : `${value.slice(0, length)}…`;
}

export function resultLabel(value: string): string {
  const labels: Record<string, string> = {
    in_progress: "ЗАГРУЗКА",
    success: "УСПЕХ",
    failed: "СБОЙ",
    cancelled: "ОТМЕНА",
    interrupted: "ПРЕРВАНА",
    licensed: "ЛИЦЕНЗИЯ",
    pirated: "ПИРАТКА",
    unknown: "НЕИЗВЕСТНО",
    healthy: "НОРМА",
    degraded: "ДЕГРАДАЦИЯ",
    ok: "НОРМА",
    running: "ВЫПОЛНЯЕТСЯ",
    error: "ОШИБКА"
  };
  return labels[value] ?? value.toUpperCase();
}

export function last24HourSeries<T extends { bucket_start: string }>(
  rows: T[],
  valueOf: (row: T) => number | null | undefined
): { values: number[]; labels: string[] } {
  const hourMs = 60 * 60 * 1_000;
  const currentHour = Math.floor(Date.now() / hourMs) * hourMs;
  const byHour = new Map(
    rows.map((row) => [
      Math.floor(Date.parse(row.bucket_start) / hourMs) * hourMs,
      valueOf(row) ?? 0
    ])
  );
  const hours = Array.from(
    { length: 24 },
    (_, index) => currentHour - (23 - index) * hourMs
  );
  return {
    values: hours.map((hour) => byHour.get(hour) ?? 0),
    labels: hours.map((hour) =>
      new Date(hour).toLocaleString("ru-RU", {
        day: "2-digit",
        month: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        timeZone: "Europe/Moscow"
      })
    )
  };
}
